export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';

export const FETCH_PRODUCT_REQUEST = 'FETCH_PRODUCT_REQUEST';
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS';
export const FETCH_PRODUCT_FAILURE = 'FETCH_PRODUCT_FAILURE';

import { ShopifyClient, getGraphQlProductId } from '../helpers';

export const fetchProductsRequest = () => {
  return{
    type: FETCH_PRODUCTS_REQUEST
  };
};

export const fetchProductsSuccess = products => {
  return {
    type: FETCH_PRODUCTS_SUCCESS,
    products
  };
};
export const fetchProductsFailure = error => {
  return {
    type: FETCH_PRODUCTS_FAILURE,
    error
  };
};

export const fetchProducts = () => {
  return dispatch => {
    dispatch(fetchProductsRequest());
    return axios(`${apiBase}/wp/v2/products`)
    .then(response => {
      return dispatch(fetchProductsSuccess(response.data.products))
    })
  };
};

export const fetchProductRequest = () => {
  return{
    type: FETCH_PRODUCT_REQUEST
  };
};

export const fetchProductSuccess = product => {
  return {
    type: FETCH_PRODUCT_SUCCESS,
    product
  };
};
export const fetchProductFailure = error => {
  return {
    type: FETCH_PRODUCT_FAILURE,
    error
  };
};

export const fetchProductById = id => {
  return dispatch => {
    dispatch(fetchProductRequest());

    const productId = getGraphQlProductId(id);

    ShopifyClient.product.fetch(productId).then(product => {
      return dispatch(fetchProductSuccess(product))
    });
  };
};

export const fetchProductByHandle = handle => {
  return dispatch => {
    dispatch(fetchProductRequest());

    ShopifyClient.product.fetchByHandle(handle).then(product => {
      return dispatch(fetchProductSuccess(product))
    });
  };
};
